export default __webpack_public_path__ + "static/media/service.aff92635.png";